import React from 'react';
import times from 'lodash/times';
import {
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
  TableTitle,
  TableWrapper,
} from '../../../../../../CommonComponents/OPL/Table/Table';
import { Shimmer } from '../../../../../../CommonComponents/OPL/Shimmer/Shimmer';

interface Props {
  isWorkflow: boolean;
}

export const LoadingTable = ({ isWorkflow }: Props) => {
  return (
    <>
      {times(3).map(i => (
        <TableWrapper mt="24" key={i} variant={isWorkflow ? 'bordered' : undefined}>
          <TableTitle>
            <Shimmer width="50%" height="36px" />
          </TableTitle>
          <TableHeader>
            <TableRow>
              <TableCell width="100%" height="16px" />
            </TableRow>
          </TableHeader>
          <TableBody>
            {times(4).map(j => (
              <TableRow pl="32" key={j}>
                <TableCell width="30%">
                  <Shimmer width="100%" height="36px" />
                </TableCell>
                <TableCell width="20%">
                  <Shimmer width="100%" height="36px" />
                </TableCell>
                <TableCell width="15%">
                  <Shimmer width="100%" height="36px" />
                </TableCell>
                <TableCell width="15%">
                  <Shimmer width="100%" height="36px" />
                </TableCell>
                <TableCell width="10%">
                  <Shimmer width="100%" height="36px" />
                </TableCell>
                <TableCell width="10%">
                  <Shimmer width="100%" height="36px" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TableWrapper>
      ))}
    </>
  );
};
